import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=31a8aa8b&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=31a8aa8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8aa8b",
  null
  
)

export default component.exports